import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import Currency from 'currency.js';

import { CurrencyJsPipe } from '../../../../modules/pipes/currency-js.pipe';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { AgentCommissionTotalReceivedDTO } from '../../../../modules/shared/models/agent-commission-total-received.dto';

@Component({
  selector: 'app-dashboard-agent-commission-transaction-total',
  templateUrl: './dashboard-agent-commission-transaction-total.component.html',
  styleUrls: ['./dashboard-agent-commission-transaction-total.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    LocalisePipe,
    CurrencyJsPipe,
  ],
})
export class DashboardAgentCommissionTransactionTotalComponent {
  @Input()
  public list?: AgentCommissionTotalReceivedDTO[];

  public readonly defaultList: AgentCommissionTotalReceivedDTO[] = [
    { year: new Date().getFullYear(), amount: Currency(0) },
  ];
}
